class exports.ChartOutput

    constructor: (@parent, @dialog, @sourceUrl, @type = 'bar', @xAxes = [], @yAxes = [], @options = {}, @getDataFn = @getData) ->
        @registerVerticalLinePlugin()
        return

    registerVerticalLinePlugin: () =>
        verticalLinePlugin =
            renderVerticalLine: (chartInstance, line) ->
                xScale = chartInstance.scales['x-axis-0']
                percentage = (line.value - xScale.min) / (xScale.max - xScale.min)
                lineLeftOffset = xScale.left + percentage * (xScale.right - xScale.left)

                # render vertical line
                yScale = chartInstance.scales['y-axis-0']
                context = chartInstance.chart.ctx
                context.beginPath()
                context.strokeStyle = line.color ? '#000000'
                context.lineWidth = line.width
                context.moveTo(lineLeftOffset, yScale.top)
                context.lineTo(lineLeftOffset, yScale.bottom)
                context.stroke()

            afterDatasetsDraw: (chart, easing) ->
                if chart.options.plugins.lineAtValues
                    for line in chart.options.plugins.lineAtValues
                        @renderVerticalLine(chart, line)

        Chart.plugins.register(verticalLinePlugin)

    createChart: () ->
        canvas = @dialog.dialog.find('.chart')
        return unless canvas.length > 0
        ctx = canvas[0].getContext '2d'

        options = $.extend true, @options,
            scales:
                xAxes: @xAxes
                yAxes: @yAxes
            responsiveAnimationDuration: 200

        @chart = new Chart ctx,
            type: @type
            options: options

    destroy: () ->
        @chart?.destroy()

    getData: () =>
        $.get @sourceUrl,
            query: @parent.filters

    buildTable: () ->
        @createChart() unless @chart?
        return unless @chart?
        @getDataFn().then (config) =>
            # console.log config
            $.extend true, @chart.options, config.options
            @chart.data.labels = config.data.labels or []
            datasets = config.data.datasets

            # Check for gradients
            for dataset in datasets
                bg = dataset.backgroundColor
                if typeof bg is 'object' and not Array.isArray(bg)
                    gradient = @chart.ctx.createLinearGradient 0, @chart.ctx.canvas.height, 0, 0
                    gradient.addColorStop 0, bg.from
                    gradient.addColorStop 1, bg.to
                    dataset.backgroundColor = gradient

            @chart.data.datasets = datasets
            @chart.update()

    resizeTable: () ->
        return
